<!--
component: MenuSearchMethod
author: Ken Nakamura
description: 検索方法指定メニュー画面
-->
<template>
  <section class="menu">
      <div class="head-message">
        {{ message }}
      </div>
      <section class="py-3 text-center container-fluid">
        <v-row>
          <v-col cols="12" xs="12" sm="4" md="3" lg="4" class="py-3">
            <div class="ges-button ges-button-search-addr" @click="searchAddr">
              地番検索
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="4" md="3" lg="4" class="py-3">
            <div class="ges-button ges-button-search-no" @click="searchNo"
             v-show="searchNoVisible">
              番号検索
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="4" md="3" lg="4" class="py-3">
            <div class="ges-button ges-button-search-plotmap" @click="searchPlotMap"
             v-show="plotmapVisible">
              地図検索
            </div>
          </v-col>
        </v-row>
      </section>
      <section class="py-3 text-center container-fluid">
        <v-row>
          <v-col cols="12" xs="12" sm="4" md="3" lg="4" class="py-3">
            <div class="ges-button ges-button-search-attr" @click="searchAttr"
             v-show="attrVisible">
             詳細検索<br/>(システム台帳)
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="4" md="3" lg="4" class="py-3">
            <div class="ges-button ges-button-search-attr" @click="searchKamiAttr"
             v-show="attrVisible">
             詳細検索<br/>(紙台帳)
            </div>
          </v-col>
        </v-row>
      </section>
  </section>
</template>

<script>
import { dbglog } from '../common/utils.js'

export default {
  mounted () {
    if (this.$store.state.userInfo.appMode > 0 && this.$store.state.userInfo.appMode < 0xff) {
      this.$store.commit('setCurrentPage', 1);
    }
    else {
      this.$store.commit('setCurrentPage', 2);
    }
    dbglog(`MenuSearchMethod.mounted: ${this.token}`);
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }
    else if (!this.searchNoVisible && !this.plotmapVisible && !this.attrVisible) {
      this.$store.commit('setSearchMode', 0);
      this.$router.replace('wards');
    }
    else {
      this.message = '検索方法を選択してください';
    }
  },
  computed: {
    mode: {
      get() { return this.$store.state.mode; },
      set(val) { this.$store.commit('setMode', val); }
    },
    authority () {
      //return this.$store.state.authority;
      return this.$store.state.userInfo.authority;
    },
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    searchNoVisible () {
      // 建築計画概要書では外部Web非公開
      //return (this.mode != 1 || this.authority > 0);
      // authority=5 は番号検索なし
      return (this.mode != 1 || (this.authority > 0 && this.authority != 5));
    },
    plotmapVisible () {
      // 建築、開発・造成・土石の堆積のみ（外部Web非公開）
      //return (this.mode == 1 || this.mode == 5 || this.mode == 6) && this.authority > 0;  // 仮
      return (this.mode == 1 || this.mode == 5 || this.mode == 6)
        && this.authority > 0 && this.authority != 4;  // authority=4 は住所検索と番号検索のみ
    },
    attrVisible () {
      // 建築のみ（庁内のみ）
      //return this.mode == 1 && this.authority > 1;
      // authority=4 は住所検索と番号検索のみ（仮）
      //return this.mode == 1 && this.authority > 1 && this.authority != 4;
      // authority=5 はauthority=1で番号検索なし
      return this.mode == 1 && this.authority > 1 && this.authority != 4 && this.authority != 5;
    },
  },
  methods: {
    searchAddr () {
      this.$store.commit('setSearchMode', 0);
      this.$router.push('wards');
    },
    searchKamiAttr () {
      this.$store.commit('setSearchMode', 0);
//      this.$router.push('kousakuwards');
      this.$router.push('kamisearchattr');
      //this.$router.push('kami-viewing-mode-search');
    }, 
    searchNo () {
      if (this.mode == 4) {
        this.$store.commit('setShiteiNo', null);
        this.$router.push('searchShiteiNo');
      }
      else {
        this.$store.commit('setSearchNendo', null);
        this.$store.commit('setWard', {code:0,name:''});
        this.$store.commit('setSearchBango', '');
        this.$router.push('searchNo');
      }
    },
    searchPlotMap () {
      this.$store.commit('setSearchMode', 1);
      this.$router.push('wards');
      //this.$router.push({ name: 'wards', params: { searchMode: 1 } });
    },
    searchAttr () {
      this.$router.push('searchAttr');
    },
    logout () {
      this.mode = 0;
      this.$router.push('login');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/common/common.css";
.ges-button {
  font-size: calc(1.1rem + 3.0vw);
}

/* method menu */
.ges-button-search-addr {
  background: linear-gradient(#208580, #bbf5eb);
  color: #8b1919;
  padding: 1.2em 0.2em;
  margin: 0.3em;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.ges-button-search-no {
  background: linear-gradient(#208580, #bbf5eb);
  color: #115c45;
  padding: 1.2em 0.2em;
  margin: 0.3em;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.ges-button-search-plotmap {
  background: linear-gradient(#208580, #bbf5eb);
  color: #3885c4;
  padding: 1.2em 0.2em;
  margin: 0.3em;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.ges-button-search-attr {
  background: linear-gradient(#208580, #bbf5eb);
  color: #0a2377;
  padding: 1.2em 0.2em;
  margin: 0.3em;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

</style>